import { render, staticRenderFns } from "./monedero-user-overview.vue?vue&type=template&id=5a630c6a&"
import script from "./monedero-user-overview.vue?vue&type=script&lang=js&"
export * from "./monedero-user-overview.vue?vue&type=script&lang=js&"
import style0 from "./monedero-user-overview.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports